import React from 'react';

const APP_ICON_SRC = {
  cofounderhubs: '/other-apps/cofounderhubs.png',
  hireproof: '/img/hireproof.png',
  cursor: '/other-apps/cursor.png',
  kiro: '/other-apps/kiro.png',
  vscode: '/other-apps/vscode.svg',
  claude: '/other-apps/claude.png',
};

export function AppIcon({ name, className = '' }) {
  const src = APP_ICON_SRC[name];
  if (!src) {
    return <div className={className} aria-hidden="true" />;
  }

  return (
    <img
      className={className}
      src={src}
      alt=""
      width={96}
      height={96}
      decoding="async"
      draggable={false}
    />
  );
}

export function OsIcon({ os, className = '' }) {
  if (os === 'macos') {
    return (
      <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
        <path
          fill="currentColor"
          d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.22-1.98 1.08-3.13-1.05.04-2.31.7-3.05 1.53-.66.72-1.23 1.9-1.08 3.02 1.14.09 2.32-.66 3.05-1.42z"
        />
      </svg>
    );
  }

  if (os === 'windows') {
    return (
      <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
        <path fill="#F35325" d="M3 3h8.5v8.5H3z" />
        <path fill="#81BC06" d="M12.5 3H21v8.5h-8.5z" />
        <path fill="#05A6F0" d="M3 12.5h8.5V21H3z" />
        <path fill="#FFBA08" d="M12.5 12.5H21V21h-8.5z" />
      </svg>
    );
  }

  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="#F5C542"
        d="M12 2.4c-2.4 0-4.1 1.7-4.4 3.9-.2 1.4.2 2.7.7 3.7-.9.5-1.6 1.4-1.9 2.5-.5 1.9.2 3.7 1.4 4.6-.2.6-.3 1.3-.2 2 .2 1.5 1.2 2.6 2.5 3.1.6.9 1.6 1.5 2.9 1.5s2.3-.6 2.9-1.5c1.3-.5 2.3-1.6 2.5-3.1.1-.7 0-1.4-.2-2 1.2-.9 1.9-2.7 1.4-4.6-.3-1.1-1-2-1.9-2.5.5-1 .9-2.3.7-3.7C16.1 4.1 14.4 2.4 12 2.4z"
      />
      <ellipse cx="10.2" cy="8.1" rx="1" ry="1.35" fill="#1a1a1a" />
      <ellipse cx="13.8" cy="8.1" rx="1" ry="1.35" fill="#1a1a1a" />
      <path fill="#E8892D" d="M11.1 9.4c.2.7.8 1.1 1.4 1.1s1.2-.4 1.4-1.1c-.4.2-.9.3-1.4.3s-1-.1-1.4-.3z" />
      <path
        fill="#fff"
        d="M8.6 13.8c1.1 1.5 2.2 2.2 3.4 2.2s2.3-.7 3.4-2.2c.1 1.8-.6 3.4-1.8 4.2-.7.5-1.5.7-1.6.7s-.9-.2-1.6-.7c-1.2-.8-1.9-2.4-1.8-4.2z"
      />
      <path fill="#1a1a1a" d="M7.2 15.6c-.6.4-1.2.4-1.5-.1-.3-.5 0-1.1.7-1.4.6-.2 1.1 0 1.3.4.1.4-.1.8-.5 1.1zm9.6 0c.6.4 1.2.4 1.5-.1.3-.5 0-1.1-.7-1.4-.6-.2-1.1 0-1.3.4-.1.4.1.8.5 1.1z" />
    </svg>
  );
}

export function DownloadArrowIcon({ className = '' }) {
  return (
    <svg className={className} viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M12 3.5a1 1 0 0 1 1 1v8.2l2.6-2.6a1 1 0 1 1 1.4 1.4l-4.3 4.3a1 1 0 0 1-1.4 0L6.9 11.5a1 1 0 1 1 1.4-1.4L11 12.7V4.5a1 1 0 0 1 1-1z"
      />
      <path
        fill="currentColor"
        d="M5 17.5a1 1 0 0 1 1-1h12a1 1 0 1 1 0 2H6a1 1 0 0 1-1-1z"
      />
    </svg>
  );
}
